const headerMapping = {
    'Articol': 'article',
    'Descriere': 'details',
    'Cantitate': 'quantity',
    'Pret Unitar Fara TVA': 'unitPriceWithoutVat',
    'Cota TVA': 'vatValue',
    'UM': 'unit',
    'Numar Obiect': 'objectNumber',
    'Centru de Cost': 'costCenter',
    'Grupa de Cheltuieli': 'expenseGroup',
    'Data Inceput Perioada': 'invoicePeriodStartDate',
    'Data Sfarsit Perioada': 'invoicePeriodEndDate'
  };
  
  export default headerMapping;
  